import { render, staticRenderFns } from "./AcceptInviteContainer.vue?vue&type=template&id=6605ab7a&scoped=true"
import script from "./AcceptInviteContainer.vue?vue&type=script&lang=js"
export * from "./AcceptInviteContainer.vue?vue&type=script&lang=js"
import style0 from "./AcceptInviteContainer.vue?vue&type=style&index=0&id=6605ab7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605ab7a",
  null
  
)

export default component.exports